<section class="spinner">
	<mat-spinner color="primary"></mat-spinner>
</section>
